const paymentInfoStyle = {
    outerBox: `bg-themeColor border border-lightborderColor rounded-[19px] p-6 h-auto  w-full`,
    borderBottom: 'border-b border-white pb-2',
    borderTop: 'border-t border-white pb-2 mb-3',
    heading: 'text-[25px] font-semibold text-left text-white',
    payment_methods: 'flex flex-wrap justify-center items-center py-4 gap-4',
    buttonContainer:'w-auto h-auto',
    button:'w-auto h-[20px]',
    other_payment_buttons: `h-[50px]`
};

const checkoutFormStyles = {
    form: 'flex flex-col gap-4 pt-2',
    inputContainer: `flex flex-col gap-1`,
    label: 'text-[12px] text-[#8B8E98] ',
    inputField: `border-[1px] rounded-[5px] py-[10px] px-[13px] text-[15px] font-[300] text-[#020529] transition duration-300 ease-in-out
                 focus:outline-[0] focus:border-stripeColorPrimary stripeFocusBoxShadow
    `,

    // outline: var(--focusOutline);
    // border-color: var(--colorPrimary);
    // box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), var(--focusBoxShadow);
    paymentElement: `flex flex-col gap-[25px]`,
    
}
const timerStyles = {
    container: 'text-[18px] text-white font-semibold text-center',
};

export { paymentInfoStyle, checkoutFormStyles, timerStyles };